"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Companies = void 0;
var Companies_1 = require("./Companies");
Object.defineProperty(exports, "Companies", { enumerable: true, get: function () { return Companies_1.Companies; } });
